export const ErrorPageImage = () => {
  return (
    <svg width="568" height="300" viewBox="0 0 568 300" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M431.317 26.7041C429.536 15.0632 418.313 4.6037 406.59 5.72754C395.65 7.31074 384.918 12.7643 378.794 21.967C372.669 31.1697 372.093 44.3092 378.931 52.995C383.234 58.4618 390.038 61.7342 396.977 62.2414C403.916 62.7486 410.927 60.6145 416.745 56.7982C426.592 50.3393 433.098 38.345 431.317 26.7041Z"
        fill="#E2E2FC"
      />
      <path
        d="M241.638 245.16C250.744 238.942 255.03 225.23 249.333 215.788C243.566 207.192 234.615 200.339 224.365 198.896C214.115 197.453 202.788 202.288 198.224 211.578C195.351 217.426 195.344 224.495 197.726 230.559C200.108 236.623 204.749 241.678 210.328 245.044C219.769 250.743 232.531 251.379 241.638 245.16Z"
        fill="#E2E2FC"
      />
      <path
        d="M23.7846 78.4282C20.1366 54.9408 27.4507 28.9861 44.2593 14.2714C61.0678 -0.444315 87.1765 -1.53777 103.456 13.9001C114.901 24.7544 120.262 41.3263 127.077 56.2624C133.892 71.1985 144.229 86.3221 159.072 88.8996C171.878 91.1233 184.754 83.3086 197.603 85.1852C210.148 87.0173 220.654 98.4642 224.263 111.993C227.872 125.521 225.177 140.543 218.702 152.67C212.227 164.796 202.268 174.24 191.363 181.395C156.28 204.417 109.724 203.668 75.2499 179.527C40.7768 155.386 19.9295 108.934 23.2568 63.6739"
        fill="#E2E2FC"
      />
      <path
        d="M149.865 82.9954C149.865 92.1604 142.436 99.1577 133.27 99.1577H64.4237L66.6097 85.4541C66.6097 85.4541 59.9933 85.1057 58.567 83.8806C46.4022 73.4322 48.6975 61.0608 56.2121 50.4414L132.605 65.5172L137.899 67.055C141.351 68.0576 144.384 70.1539 146.542 73.0286C148.7 75.9033 149.866 79.4009 149.865 82.9954Z"
        fill="#7E7EB9"
      />
      <path
        d="M132.442 82.9941C132.442 92.1591 125.013 98.94 115.847 98.94H38.3433L49.1867 83.0721C49.1867 83.0721 42.6211 81.3687 41.144 80.2054C29.7411 71.1573 31.2745 56.5198 38.7892 45.9004L115.182 65.5213L120.476 67.0591C123.927 68.0614 126.959 70.1569 129.117 73.0305C131.275 75.9041 132.442 79.4006 132.442 82.9941Z"
        fill="white"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M83.4762 87.9957C83.4762 87.9957 58.4055 85.0175 49.1875 82.6367"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.1009 99.1558H1.50827C0.0841223 99.1558 -0.541374 97.3605 0.573268 96.4764C8.47315 90.2127 27.9989 75.388 33.0688 75.3848C36.9787 75.3848 41.2339 80.5998 49.9443 82.5271L39.1009 99.1558Z"
        fill="#2E3860"
      />
      <path
        d="M219.803 99.1563H184.338C184.338 99.1563 192.007 91.2748 202.568 90.6406C204.723 91.9392 210.755 92.9035 214.489 93.4781C218.224 94.0527 219.803 99.1563 219.803 99.1563Z"
        fill="#C9A2A3"
      />
      <path
        d="M202.566 90.6404C192.005 91.2746 184.336 99.156 184.336 99.156L144.133 51.0219C143.372 50.1095 142.307 49.5022 141.135 49.3114C139.962 49.1206 138.76 49.359 137.748 49.983L121.423 61.1359C120.882 82.3347 119.691 104.049 119.656 106.612C119.638 107.66 119.761 108.704 120.02 109.719C118.898 108.388 113.839 108.296 108.144 109.585C102.517 110.859 98.0207 113.048 97.4937 114.719C97.3106 113.56 97.1967 112.392 97.1528 111.22C96.6636 98.8747 95.7459 75.7323 95.4895 60.9541L38.1406 46.2246C46.6195 34.2439 64.2817 23.7922 82.9427 20.5944C105.431 16.7397 125.197 17.2245 136.536 18.0772C139.634 18.3106 142.648 19.1934 145.383 20.6682C148.117 22.143 150.51 24.1767 152.407 26.6373C166.536 44.978 200.846 89.6069 202.566 90.6404Z"
        fill="#2E3860"
      />
      <path
        d="M111.377 24.7852C116.571 28.1193 121.722 34.9262 121.678 48.4848C121.6 73.2039 119.815 103.372 119.768 106.613C119.751 107.66 119.873 108.705 120.132 109.72C119.011 108.389 113.95 108.297 108.257 109.586C102.63 110.859 98.1333 113.049 97.6052 114.719C97.4225 113.561 97.3091 112.393 97.2654 111.221C96.693 96.7639 95.5339 67.5008 95.5339 54.203C95.5334 52.3836 94.8101 50.6388 93.5233 49.3526C92.2364 48.0663 90.4913 47.3439 88.6719 47.3442"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M136.531 18.0762C139.629 18.3089 142.644 19.1916 145.379 20.6666C148.114 22.1416 150.508 24.1759 152.405 26.6373C166.536 44.9812 200.845 89.6102 202.567 90.6436C192.006 91.2778 184.337 99.1593 184.337 99.1593L144.135 51.0252C143.374 50.113 142.309 49.5058 141.136 49.315C139.964 49.1242 138.761 49.3625 137.75 49.9863L121.678 60.9661"
        stroke="white"
        strokeWidth="0.692869"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M132.716 30.9307C132.716 30.9307 131.742 30.9047 129.714 31.7467C128.619 32.2023 127.215 32.9089 125.493 34.0084C122.463 35.9412 120.005 19.4845 127.701 17.6016L136.534 17.9186L132.716 30.9307Z"
        fill="#C9A2A3"
      />
      <path
        d="M136.52 17.9404L132.716 30.9265C132.716 30.9265 131.743 30.9005 129.715 31.7425C126.226 25.3576 135.558 17.8906 135.558 17.8906L136.52 17.9404Z"
        fill="#2E3860"
      />
      <path
        d="M80.5634 18.1267C82.8728 18.1267 84.7449 16.2546 84.7449 13.9452C84.7449 11.6358 82.8728 9.76367 80.5634 9.76367C78.254 9.76367 76.3818 11.6358 76.3818 13.9452C76.3818 16.2546 78.254 18.1267 80.5634 18.1267Z"
        fill="#EE4360"
      />
      <path
        d="M149.595 21.1927C149.47 21.7175 149.271 22.3755 149.12 22.8506C149.12 22.8506 149.093 22.935 149.057 23.0421C147.995 23.1622 143.406 24.1243 139.202 20.7511C138.324 20.0572 137.693 19.0991 137.402 18.0186C134.199 17.8022 128.968 17.6128 124.857 17.5273C124.168 17.5136 123.467 17.5025 122.753 17.4938C112.948 17.3856 100.76 17.879 87.4362 19.8551C87.2387 18.8692 87.1393 17.8662 87.1396 16.8607C87.1396 7.54644 95.586 -0.00390625 106.006 -0.00390625C114.807 -0.00390625 122.2 5.38316 124.284 12.6705C124.936 11.9436 125.734 11.3633 126.627 10.9682C127.519 10.573 128.485 10.372 129.461 10.3785C132.458 10.3785 134.998 12.0191 135.88 14.4983C141.679 7.97822 150.983 13.9735 149.595 21.1927Z"
        fill="#EE4360"
      />
      <path
        d="M137.312 17.6168L137.323 17.6081C137.331 17.6817 137.53 19.4035 139.204 20.7465C143.389 24.1088 147.954 23.1662 149.044 23.0396C145.709 31.2836 133.988 33.0075 133.028 31.6018C128.985 25.6649 133.175 21.043 133.417 20.78L131.813 19.2043C131.576 18.9721 131.387 18.6956 131.258 18.3906C131.128 18.0855 131.06 17.7579 131.057 17.4264C131.054 17.0949 131.116 16.7661 131.24 16.4587C131.364 16.1513 131.547 15.8713 131.78 15.6348C132.012 15.3982 132.288 15.2098 132.593 15.0801C132.898 14.9504 133.226 14.8821 133.557 14.879C133.889 14.8759 134.218 14.9382 134.525 15.0622C134.833 15.1862 135.113 15.3696 135.349 15.6018L137.312 17.6168Z"
        fill="#C9A2A3"
      />
      <path
        d="M134.644 19.2328C135.412 18.4504 135.45 17.2405 134.728 16.5273"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M145.929 27.4795C145.929 27.4795 142.756 24.1886 138.322 28.8008"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M138.691 24.4404C139.13 24.0782 139.329 23.5951 139.137 23.3614C138.944 23.1277 138.432 23.2319 137.993 23.5941C137.554 23.9564 137.355 24.4394 137.548 24.6731C137.74 24.9068 138.253 24.8026 138.691 24.4404Z"
        fill="#2E3860"
      />
      <path
        d="M142.616 28.7811C142.982 28.4794 143.148 28.0771 142.987 27.8826C142.827 27.6881 142.4 27.775 142.035 28.0767C141.669 28.3785 141.503 28.7807 141.664 28.9752C141.824 29.1697 142.251 29.0828 142.616 28.7811Z"
        fill="#2E3860"
      />
      <path
        d="M130.927 17.8613C131.04 18.299 131.27 18.6979 131.591 19.016L133.159 20.6793"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M138.895 173.141C135.881 173.141 132.889 172.817 129.938 172.169C123.823 170.826 119.038 168.853 115.356 166.148C111.377 167.544 106.637 168.58 101.185 168.724C85.4695 169.147 62.8282 162.392 45.3846 148.275C44.5025 146.398 43.0759 145.165 42.2666 143.078C59.0534 156.666 86.2351 165.675 101.094 165.275C105.311 165.164 109.064 164.478 112.328 163.505C108.273 159.28 106.234 153.758 106.259 147.053C106.287 139.697 109.416 136.366 112.035 134.867C115.746 132.744 120.814 133.035 125.262 135.627C130.169 138.485 133.086 143.323 133.065 148.568C133.048 152.797 130.956 156.934 127.468 159.634C125.628 161.059 122.861 162.919 119.228 164.586C122.279 166.398 126.084 167.79 130.678 168.799C135.899 169.946 141.272 169.985 146.646 168.919C161.412 165.989 173.743 160.751 183.297 153.349C190.894 147.464 196.771 140.196 200.764 131.749C207.565 117.361 206.537 104.446 206.525 104.317L206.521 104.254C205.673 87.1758 195.698 70.4922 181.111 61.7482C168.454 54.1619 152.243 52.082 135.463 55.8941C125.034 58.263 110.845 63.8843 102.481 77.2082C93.4722 91.5595 95.9159 109.378 103.346 117.656C108.648 123.564 118.808 121.434 126.971 119.723C127.893 119.529 128.793 119.341 129.661 119.168C138.443 117.422 174.062 100.716 174.199 100.668L174.954 103.507C174.383 103.708 139.358 120.759 130.333 122.553C129.476 122.723 128.589 122.909 127.679 123.1C118.648 124.993 107.408 127.349 100.777 119.96C95.979 114.615 93.3121 106.898 93.2671 98.2305C93.2255 90.1399 95.5182 81.8081 99.5576 75.3727C108.552 61.0463 123.631 55.0419 134.699 52.5282C152.347 48.5192 169.462 50.742 182.885 58.7875C198.423 68.1018 209.051 85.8662 209.966 104.052C210.042 104.987 210.97 118.229 203.883 133.222C199.656 142.166 193.441 149.855 185.41 156.076C175.428 163.808 162.612 169.268 147.317 172.303C144.506 172.862 141.692 173.141 138.895 173.141ZM117.616 136.899C116.202 136.899 114.876 137.218 113.75 137.862C111.124 139.365 109.727 142.547 109.71 147.066C109.686 153.526 111.715 158.526 115.961 162.237C120.211 160.53 123.369 158.443 125.356 156.905C128.01 154.85 129.601 151.728 129.614 148.554C129.63 144.557 127.353 140.839 123.525 138.609C121.582 137.476 119.519 136.899 117.616 136.899Z"
        fill="#EE4360"
      />
      <path
        d="M118.145 167.939C118.128 167.978 117.604 167.779 116.844 167.31C116.079 166.847 115.081 166.123 114.038 165.252C113 164.373 112.115 163.512 111.538 162.828C110.952 162.15 110.69 161.652 110.727 161.63C110.771 161.602 111.095 162.04 111.716 162.665C112.328 163.297 113.229 164.12 114.256 164.991C115.29 165.853 116.255 166.601 116.976 167.108C117.693 167.622 118.166 167.892 118.145 167.939Z"
        fill="#2E3860"
      />
      <path
        d="M121.772 165.918C121.767 165.953 121.146 165.887 120.215 165.522C119.283 165.167 118.074 164.48 116.89 163.53C115.708 162.576 114.774 161.558 114.178 160.766C113.576 159.974 113.297 159.424 113.331 159.404C113.377 159.374 113.725 159.874 114.365 160.614C115 161.357 115.944 162.329 117.104 163.265C118.266 164.197 119.423 164.898 120.31 165.301C121.194 165.714 121.785 165.861 121.772 165.918Z"
        fill="#2E3860"
      />
      <path
        d="M107.94 153.978C107.917 153.985 107.842 153.785 107.723 153.416C107.6 153.049 107.461 152.505 107.323 151.826C107.044 150.469 106.842 148.545 106.987 146.427C107.138 144.309 107.606 142.432 108.071 141.128C108.302 140.474 108.516 139.955 108.689 139.609C108.857 139.26 108.961 139.073 108.982 139.082C109.035 139.106 108.7 139.891 108.3 141.203C107.898 142.513 107.476 144.366 107.327 146.451C107.184 148.536 107.345 150.43 107.56 151.783C107.773 153.138 107.995 153.962 107.94 153.978Z"
        fill="white"
      />
      <path
        d="M99.3181 166.385C99.3243 166.424 98.6931 166.577 97.6497 166.673C96.6076 166.77 95.1491 166.78 93.5617 166.557C91.9744 166.33 90.5769 165.914 89.6027 165.531C88.6264 165.148 88.0631 164.826 88.0805 164.79C88.1026 164.74 88.6992 164.984 89.6838 165.304C90.6669 165.624 92.0492 165.996 93.6103 166.22C95.1706 166.439 96.6021 166.467 97.6358 166.432C98.6696 166.398 99.3105 166.331 99.3181 166.385Z"
        fill="white"
      />
      <path
        d="M194.841 143.423C194.876 143.449 194.506 144.037 193.829 144.932C193.153 145.827 192.158 147.02 190.963 148.248C189.766 149.475 188.598 150.5 187.72 151.199C186.843 151.899 186.265 152.283 186.238 152.249C186.206 152.209 186.732 151.758 187.564 151.015C188.398 150.273 189.53 149.228 190.718 148.011C191.905 146.792 192.92 145.633 193.641 144.782C194.362 143.93 194.801 143.393 194.841 143.423Z"
        fill="white"
      />
      <path
        d="M96.0147 108.12C95.9925 108.127 95.8685 107.8 95.6627 107.2C95.45 106.603 95.1964 105.72 94.9345 104.617C94.6664 103.515 94.4322 102.182 94.2541 100.692C94.0947 99.1991 94.0033 97.5487 94.0421 95.8158C94.0947 94.0829 94.2728 92.4388 94.5098 90.9567C94.7654 89.4774 95.0703 88.1589 95.396 87.0718C95.7154 85.984 96.0154 85.1158 96.2593 84.5304C96.4962 83.9428 96.6376 83.6227 96.6591 83.631C96.6812 83.6393 96.5815 83.9761 96.384 84.5754C96.1789 85.172 95.9163 86.047 95.6288 87.1355C95.335 88.2234 95.0571 89.5363 94.8209 91.0059C94.6026 92.4776 94.4356 94.1072 94.3837 95.8241C94.3456 97.541 94.4266 99.1762 94.5673 100.658C94.7266 102.137 94.9345 103.463 95.1708 104.565C95.4008 105.667 95.6177 106.555 95.7909 107.162C95.9558 107.771 96.0376 108.113 96.0147 108.12Z"
        fill="white"
      />
      <path
        d="M100.206 77.0235C100.288 77.0699 99.9106 77.8979 99.3625 78.8728C98.8145 79.8484 98.3045 80.6008 98.2221 80.5551C98.1403 80.5087 98.5172 79.6814 99.0653 78.7058C99.6127 77.7303 100.123 76.9771 100.206 77.0235Z"
        fill="white"
      />
      <path
        d="M212.043 74.8254L212.043 74.8253C211.74 73.2677 212.757 71.7588 214.315 71.4559C215.873 71.1522 217.382 72.1697 217.685 73.7274L217.685 73.7275M212.043 74.8254L217.194 73.8229L217.685 73.7275M212.043 74.8254L212.232 75.7965L199.953 78.8173L199.953 78.8173C197.033 79.5361 194.8 81.6024 193.751 84.1895L186.318 86.0182C186.318 86.0183 186.318 86.0183 186.318 86.0183C183.387 86.739 181.597 89.6997 182.317 92.6303L182.317 92.6304L182.888 94.9503L175.852 96.6815C173.497 97.2609 172.056 99.6409 172.636 101.997L172.636 101.997C173.215 104.353 175.595 105.793 177.951 105.214L177.951 105.214L184.986 103.483L185.401 105.168C185.401 105.169 185.401 105.169 185.401 105.169C186.122 108.1 189.083 109.89 192.013 109.169L192.013 109.169L199.639 107.293M212.043 74.8254L199.639 107.293M217.685 73.7275L223.844 105.387L217.685 73.7275ZM218.693 106.389L218.203 106.485C218.506 108.042 220.014 109.06 221.572 108.757L221.572 108.757C223.13 108.453 224.148 106.945 223.844 105.387L221.477 108.266C220.19 108.516 218.944 107.676 218.693 106.389ZM218.693 106.389L218.657 106.201L218.693 106.389ZM199.639 107.293C201.745 108.953 204.564 109.668 207.374 108.977L218.171 106.32L218.203 106.485L199.639 107.293Z"
        fill="#EE4360"
        stroke="#2E3860"
      />
      <path d="M213.001 78L218.001 104" stroke="#2E3860" strokeLinecap="round" />
      <path d="M194.884 85.4121L199.119 105.588" stroke="#2E3860" strokeLinecap="round" />
      <path d="M183.501 96L185.001 102" stroke="#2E3860" strokeLinecap="round" />
      <path
        d="M192.187 86.4335C192.193 86.484 191.445 86.597 190.254 86.8457C189.659 86.9718 188.95 87.1312 188.178 87.3446C187.409 87.5601 186.571 87.8379 185.781 88.2904C185 88.7442 184.294 89.3158 184.098 90.0572C183.885 90.7923 183.988 91.5274 184.054 92.124C184.208 93.3268 184.409 94.0578 184.357 94.0723C184.318 94.0848 184.034 93.3739 183.815 92.16C183.721 91.56 183.577 90.8069 183.795 89.9692C183.905 89.5535 184.155 89.1467 184.485 88.8273C184.814 88.5038 185.198 88.2349 185.611 87.9945C186.441 87.5192 187.31 87.2441 188.097 87.0411C188.886 86.8409 189.604 86.7058 190.209 86.6088C191.422 86.4189 192.182 86.3905 192.187 86.4335Z"
        fill="white"
      />
      <path
        d="M210.418 78.0356C210.423 78.0585 210.188 78.1278 209.762 78.2338C209.335 78.3391 208.715 78.4811 207.948 78.6495C206.328 78.9904 204.248 79.4276 201.947 79.9112C200.789 80.1794 199.707 80.5223 198.81 81.0094C197.91 81.4854 197.215 82.1097 196.741 82.7125C195.78 83.943 195.775 84.9914 195.706 84.9671C195.69 84.9664 195.671 84.7184 195.759 84.2791C195.852 83.8446 196.076 83.2197 196.548 82.567C197.018 81.9185 197.729 81.2457 198.66 80.7337C199.584 80.2126 200.697 79.851 201.871 79.5794C204.224 79.0743 206.353 78.698 207.901 78.4132C208.675 78.2754 209.302 78.1694 209.736 78.1042C210.17 78.0377 210.414 78.0128 210.418 78.0356Z"
        fill="white"
      />
      <path
        d="M182.175 97.0425C182.193 97.08 181.706 97.3592 180.837 97.5747C179.973 97.8082 178.744 97.9066 177.45 98.1809C176.805 98.3251 176.206 98.5232 175.709 98.7893C175.211 99.054 174.812 99.3796 174.525 99.6949C173.945 100.332 173.832 100.889 173.775 100.869C173.742 100.873 173.769 100.267 174.341 99.5383C174.624 99.1807 175.034 98.8121 175.558 98.5135C176.082 98.2128 176.709 97.9966 177.376 97.8477C178.715 97.565 179.93 97.5075 180.786 97.3384C181.646 97.1887 182.155 96.9947 182.175 97.0425Z"
        fill="white"
      />
      <path
        d="M215.598 72.6429C215.594 72.6956 215.346 72.6908 214.98 72.7898C214.617 72.8841 214.129 73.1113 213.762 73.5388C213.398 73.9684 213.251 74.486 213.215 74.8594C213.176 75.2364 213.219 75.4809 213.168 75.4941C213.13 75.5073 212.996 75.2759 212.974 74.8532C212.948 74.4389 213.073 73.8243 213.503 73.3178C213.935 72.8134 214.522 72.5931 214.935 72.5529C215.356 72.5078 215.606 72.6028 215.598 72.6429Z"
        fill="white"
      />
      <path
        d="M126.876 125.441C126.876 125.441 126.281 128.739 115.473 132.15C115.473 132.15 100.566 130.58 97.6562 115.614C97.5977 115.32 97.5447 115.02 97.4971 114.715C98.0252 113.044 102.522 110.855 108.149 109.581C113.842 108.292 118.903 108.384 120.024 109.715C120.089 109.972 120.162 110.221 120.24 110.463C121.624 114.656 124.991 116.753 124.991 116.753C124.991 116.753 125.515 119.159 120.076 118.113C114.637 117.068 118.698 124.791 126.876 125.441Z"
        fill="#C9A2A3"
      />
      <path
        d="M118.719 130.636C118.719 130.636 113.361 130.208 108.199 125.812"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M123.265 128.579C123.265 128.579 117.907 128.152 112.745 123.756"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M258 52L261 61.5H256L259.5 81M247 73L249.5 78M249.5 97L234 104M256.5 101.5L250.5 108.5M262 103L259 132M271 64L263 80M322.5 62.5L296 76L291.5 70.5L267.5 84.5M291.5 82.5L272.5 88M317.5 88L298.5 91.5L298 88.5L278.5 93"
        stroke="#2E3860"
        strokeLinecap="round"
      />
      <path
        d="M563.449 175.236C562.783 160.654 554.285 146.191 540.056 138.025C525.828 129.86 506.008 128.748 491.342 136.335C482.208 141.061 475.577 148.589 470.06 156.374C467.038 160.64 463.88 165.346 458.449 167.213C451.382 169.642 443.613 166.33 436.138 165.062C426.345 163.4 415.757 165.497 407.837 170.668C401.806 174.606 397.407 180.277 395.368 186.499C388.834 209.494 407.809 225.914 428.092 235.876C450.764 247.012 479.408 247.003 504.09 239.571C520.272 234.698 535.353 226.685 546.372 215.494C557.392 204.304 564.116 189.819 563.449 175.236Z"
        fill="#E2E2FC"
      />
      <path
        d="M471.087 115.458L441.329 113.647C437.897 113.438 434.511 114.526 431.843 116.695C429.175 118.864 427.419 121.957 426.924 125.359C425.707 133.712 423.488 144.821 417.316 145.511C408.054 146.548 393.585 127.905 393.585 127.905L380.235 138.934C380.235 138.934 399.82 171.456 419.25 170.061C435.889 168.868 438.218 155.441 438.218 155.441L439.061 162.977L486.497 166.932C486.497 166.932 493.697 185.805 500.797 191.263L517.072 182.611C510.01 173.778 495.476 144.159 488.302 127.545C486.831 124.135 484.444 121.2 481.404 119.066C478.365 116.932 474.794 115.683 471.087 115.458Z"
        fill="white"
        stroke="#2E3860"
        strokeMiterlimit="10"
      />
      <path
        d="M439.052 162.901L439.849 170.027C444.789 171.031 451.592 171.825 459.157 171.737C466.742 171.646 473.648 171.122 478.652 170.279C483.656 169.437 486.768 168.272 486.729 166.904C486.678 165.104 482.915 163.383 477.017 162.231C472.196 161.291 465.945 160.725 459.119 160.813C451.258 160.896 444.088 161.698 439.052 162.901Z"
        fill="#4F5B94"
      />
      <path d="M486.487 166.815L476.506 145.6" stroke="#2E3860" strokeMiterlimit="10" />
      <path d="M438.217 155.43L436.298 138.27" stroke="#2E3860" strokeMiterlimit="10" />
      <path
        d="M500.361 191.19C501.26 192.982 505.913 192.507 510.612 190.149C515.311 187.791 518.392 184.426 517.491 182.635C516.589 180.844 511.671 181 506.972 183.358C502.273 185.716 499.462 189.402 500.361 191.19Z"
        fill="#2E3860"
      />
      <path
        d="M394.583 128.325C393.689 126.993 384.418 118.048 381.505 118.443C378.592 118.839 384.288 122.413 381.293 122.825C378.523 123.204 368.477 114.112 367.501 118.323C365.847 125.537 375.93 137.761 381.322 139.907C385.813 141.686 398.065 133.517 394.583 128.325Z"
        fill="#C9A2A3"
      />
      <path
        d="M368.66 117.548C368.66 117.548 369.39 120.865 377.664 124.609"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M367.721 118.963C367.721 118.963 368.356 123.381 376.629 127.125"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M367.72 118.965C367.72 118.965 365.948 125.585 375.397 129.773"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M385.341 127.879C385.341 127.879 385.133 131.898 387.214 134.775"
        stroke="#423C52"
        strokeWidth="0.653759"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M502.288 192.141C502.288 192.141 512.457 201.561 524.841 198.931C535.595 196.647 534.116 189.403 532.484 189.536C525.754 190.078 519.147 187.154 516.296 183.979C514.395 181.857 501.637 186.321 502.288 192.141Z"
        fill="#C9A2A3"
      />
      <path
        d="M533.291 192.243C533.291 192.243 527.188 194.808 522.01 191.851"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M531.545 195.343C531.545 195.343 526.004 197.364 521.089 195.329"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M528.913 197.219C528.913 197.219 523.567 200.138 518.889 197.604"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M439.051 162.901L451.043 270.102L473.569 267.582L467.967 217.507C474.745 238.589 516.451 253.805 516.451 253.805L525.3 232.935C525.3 232.935 493.954 223.821 484.343 193.101C482.219 186.31 480.143 177.281 478.657 170.278C477.965 167.01 477.402 164.182 477.022 162.23C472.201 161.289 465.95 160.724 459.124 160.812C451.257 160.896 444.087 161.698 439.051 162.901Z"
        fill="#C9A2A3"
      />
      <path
        d="M479.232 232.175C481.36 230.025 481.263 226.136 478.922 223.17C476.425 220.005 472.311 219.087 469.734 221.12"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M447.666 236.433C450.626 235.848 452.739 232.577 452.471 228.811C452.185 224.791 449.299 221.719 446.025 221.952"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M439.051 162.902L443.169 199.715C470.78 200.949 484.338 193.103 484.338 193.103C482.214 186.312 480.138 177.284 478.652 170.281C477.96 167.012 477.397 164.185 477.017 162.233C472.196 161.292 465.945 160.727 459.119 160.814C451.258 160.898 444.087 161.7 439.051 162.902Z"
        fill="#7E7EB9"
      />
      <path
        d="M468.096 218.658C459.24 200.547 456.208 181.785 456.208 181.785"
        stroke="white"
        strokeWidth="0.653759"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M478.61 195.085C475.815 186.148 473.084 174.265 471.128 165.049"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M480.325 194.543C477.529 185.606 474.799 173.724 472.843 164.508"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M439.052 162.902L439.849 170.028C444.79 171.032 451.592 171.826 459.157 171.738C466.742 171.647 473.649 171.123 478.652 170.28C477.961 167.012 477.397 164.184 477.017 162.232C472.196 161.291 465.945 160.726 459.119 160.814C451.258 160.897 444.088 161.699 439.052 162.902Z"
        fill="#2E3860"
      />
      <path
        d="M444.636 288.334L444.824 290.012L470.85 287.101C472.134 286.957 473.309 286.309 474.115 285.299C474.922 284.289 475.294 283 475.151 281.715L473.569 267.58L451.044 270.1C451.378 273.089 452.315 280.537 445.917 285.355C445.463 285.697 445.106 286.152 444.881 286.674C444.656 287.197 444.572 287.769 444.636 288.334Z"
        fill="#EE4360"
      />
      <path
        d="M451.008 272.996C449.915 273.271 449.319 273.58 449.365 273.988C449.426 274.535 451.399 274.531 454.814 274.149"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M450.837 276.371C449.699 276.639 449.128 277.071 449.176 277.499C449.237 278.046 451.766 277.867 455.187 277.484"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M455.563 280.873C455.563 280.873 448.343 282.195 448.185 280.778C448.117 280.173 449.151 279.839 449.999 279.668"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M450.552 265.7L473.077 263.18L473.569 267.581L451.044 270.101L450.552 265.7Z" fill="white" />
      <path
        d="M529.204 268.325L530.759 268.984L540.978 244.873C541.482 243.683 541.492 242.341 541.007 241.142C540.522 239.944 539.581 238.987 538.391 238.483L525.295 232.934L516.446 253.802C519.208 254.976 526.166 257.811 527.231 265.753C527.307 266.316 527.53 266.85 527.876 267.301C528.222 267.752 528.679 268.105 529.204 268.325Z"
        fill="#EE4360"
      />
      <path
        d="M519.126 255.267C518.829 256.352 518.865 257.175 519.245 257.336C519.753 257.55 520.714 255.834 522.057 252.664"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M522.173 257.331C521.746 258.612 521.752 259.451 522.187 259.633C522.694 259.848 523.88 257.602 525.224 254.426"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M528.523 255.863C528.523 255.863 526.122 262.694 524.804 262.135C524.219 261.888 524.501 260.891 524.786 260.089"
        stroke="#2E3860"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M525.294 232.934L519.604 230.748L510.391 251.501L516.348 253.93L525.294 232.934Z" fill="white" />
      <path
        d="M446.062 100.814C446.53 104.996 450.823 107.482 455.022 107.013C456.697 106.828 458.263 106.096 459.478 104.929C460.694 103.763 461.49 102.228 461.743 100.563C462.32 101.676 463.182 102.617 464.242 103.287C465.302 103.957 466.521 104.333 467.775 104.375C469.028 104.418 470.27 104.126 471.373 103.53C472.476 102.933 473.401 102.054 474.051 100.982C474.7 103.893 476.381 106.472 478.783 108.24C481.186 110.009 484.147 110.847 487.12 110.601C490.093 110.355 492.877 109.041 494.956 106.901C497.034 104.762 498.268 101.942 498.429 98.963C498.59 95.9842 497.667 93.0479 495.83 90.6971C493.993 88.3463 491.368 86.7401 488.438 86.1754C485.509 85.6107 482.474 86.1258 479.895 87.6254C477.317 89.125 475.368 91.5077 474.41 94.3329C473.773 92.972 472.719 91.8496 471.401 91.129C470.083 90.4084 468.569 90.127 467.08 90.3259C465.591 90.5248 464.204 91.1935 463.121 92.2348C462.038 93.2761 461.315 94.6357 461.058 96.116C460.365 94.6957 459.249 93.5248 457.864 92.7643C456.479 92.0038 454.892 91.6909 453.322 91.8687C449.129 92.3404 445.595 96.6327 446.062 100.814Z"
        fill="#2E3860"
      />
      <path
        d="M505.498 100.568C503.73 100.766 502.136 99.493 501.938 97.7247C501.74 95.9564 503.013 94.3626 504.782 94.1648C506.55 93.967 508.144 95.2401 508.342 97.0084C508.539 98.7767 507.266 100.371 505.498 100.568Z"
        fill="#2E3860"
      />
      <path
        d="M461.806 101.455C461.909 101.443 462.004 101.391 462.069 101.31C462.134 101.228 462.164 101.125 462.152 101.021L461.542 95.5637C461.53 95.4603 461.478 95.3657 461.397 95.3008C461.315 95.2358 461.212 95.2059 461.108 95.2174C461.005 95.229 460.91 95.2812 460.845 95.3624C460.78 95.4437 460.75 95.5475 460.762 95.6509L461.373 101.108C461.384 101.212 461.436 101.306 461.518 101.371C461.599 101.436 461.703 101.466 461.806 101.455Z"
        fill="#423C52"
      />
      <path
        d="M458.447 105.904L462.83 114.886C462.83 114.886 462.11 119.032 455.212 119.443C448.313 119.855 448.437 114.078 448.437 114.078L448.044 110.57L456.007 106.069L458.447 105.904Z"
        fill="#C9A2A3"
      />
      <path
        d="M448.181 111.79L462.574 115.621C462.688 115.387 462.774 115.141 462.83 114.887L458.446 105.904L456.007 106.067L448.048 110.529L448.053 110.573L448.181 111.79Z"
        fill="#423C52"
      />
      <path
        d="M450.722 111.559C453.277 111.386 455.525 109.123 456.187 106.157L458.553 105.892C458.872 105.856 459.182 105.758 459.463 105.603C459.744 105.448 459.993 105.238 460.193 104.987C460.394 104.736 460.543 104.448 460.632 104.139C460.721 103.83 460.749 103.507 460.713 103.188C460.678 102.868 460.579 102.559 460.424 102.277C460.269 101.996 460.06 101.748 459.808 101.547C459.557 101.347 459.269 101.197 458.96 101.108C458.651 101.019 458.328 100.991 458.009 101.027L455.8 101.274C455.8 101.274 455.8 101.274 455.799 101.267C455.729 101.28 455.655 101.29 455.577 101.299C452.503 101.643 448.738 98.7278 448.565 97.2157C446.114 98.1714 445.354 101.011 445.589 104.503C445.86 108.542 447.524 111.774 450.722 111.559Z"
        fill="#C9A2A3"
      />
      <path
        d="M456.803 103.933C456.756 103.512 456.878 103.089 457.142 102.758C457.407 102.426 457.792 102.213 458.213 102.166"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M452.012 105.575C451.758 105.604 451.518 105.318 451.475 104.938C451.433 104.558 451.604 104.226 451.858 104.198C452.112 104.17 452.353 104.455 452.395 104.835C452.438 105.216 452.266 105.547 452.012 105.575Z"
        fill="#423C52"
      />
      <path
        d="M447.067 106.072C446.834 106.098 446.614 105.836 446.575 105.487C446.536 105.139 446.693 104.835 446.926 104.809C447.158 104.783 447.378 105.044 447.417 105.393C447.456 105.742 447.299 106.046 447.067 106.072Z"
        fill="#423C52"
      />
      <path
        d="M453.655 102.778C453.655 102.778 452.523 101.841 450.449 102.338"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M445.427 102.636C445.427 102.636 448.47 102.296 448.945 107.46"
        stroke="#423C52"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M497.297 175.612C495.922 175.612 494.558 175.424 493.21 175.02C480.041 171.079 480.726 161.579 481.275 153.948C481.789 146.828 481.805 142.353 475.935 140.15C468.173 137.238 464.973 140.065 460.135 144.347C454.371 149.446 447.202 155.793 429.811 153.218C420.776 151.88 406.265 147.119 388.444 132.031C377.846 123.059 371.17 114.778 370.89 114.43L373.582 112.271C373.847 112.602 400.447 145.382 430.316 149.804C446.114 152.145 452.348 146.629 457.847 141.763C462.779 137.399 467.438 133.278 477.147 136.92C485.73 140.14 485.192 147.607 484.718 154.196C484.162 161.907 483.682 168.566 494.199 171.715C506.05 175.265 521.633 156.492 530.946 145.278C534.269 141.278 536.58 138.382 538.422 136.882L541.028 138.951C539.876 140.363 536.676 143.78 533.601 147.483C524.113 158.906 510.239 175.611 497.297 175.612Z"
        fill="#EE4360"
      />
      <path
        d="M448.457 148.299C448.468 148.319 448.322 148.428 448.045 148.607C447.771 148.789 447.355 149.025 446.828 149.289C445.775 149.819 444.242 150.415 442.474 150.783C440.704 151.146 439.06 151.205 437.883 151.136C437.295 151.103 436.82 151.051 436.496 150.993C436.171 150.938 435.993 150.896 435.996 150.873C436.003 150.817 436.725 150.889 437.89 150.895C439.055 150.902 440.666 150.806 442.405 150.449C444.143 150.087 445.66 149.538 446.727 149.07C447.794 148.604 448.428 148.251 448.457 148.299Z"
        fill="white"
      />
      <path
        d="M468.718 137.875C468.706 137.93 468.277 137.849 467.586 137.838C466.897 137.824 465.94 137.917 464.946 138.257C463.953 138.601 463.142 139.117 462.607 139.553C462.07 139.988 461.783 140.315 461.739 140.28C461.709 140.258 461.932 139.871 462.449 139.372C462.961 138.873 463.794 138.295 464.835 137.934C465.877 137.577 466.89 137.519 467.6 137.597C468.314 137.672 468.729 137.839 468.718 137.875Z"
        fill="white"
      />
      <path
        d="M490.787 170.603C490.779 170.637 490.157 170.533 489.23 170.123C488.305 169.718 487.1 168.954 486.043 167.815C484.99 166.672 484.322 165.41 483.99 164.457C483.654 163.501 483.6 162.872 483.634 162.867C483.692 162.854 483.83 163.459 484.215 164.369C484.596 165.278 485.274 166.477 486.293 167.584C487.316 168.686 488.458 169.456 489.335 169.906C490.212 170.361 490.804 170.546 490.787 170.603Z"
        fill="white"
      />
      <path
        d="M539.032 138.13C539.098 138.196 537.93 139.47 536.424 140.974C534.916 142.479 533.641 143.644 533.574 143.577C533.507 143.51 534.675 142.237 536.183 140.732C537.689 139.229 538.965 138.063 539.032 138.13Z"
        fill="white"
      />
      <path
        d="M373.577 114.858L373.577 114.858C372.284 116.281 370.081 116.386 368.657 115.093L362.948 109.904L367.633 104.749L373.342 109.938L373.342 109.938C374.766 111.231 374.871 113.434 373.577 114.858Z"
        fill="#EE4360"
        stroke="#2E3860"
      />
      <path
        d="M343.21 81.9101L332.722 73.2368C331.899 72.5564 331.784 71.337 332.464 70.5138C333.144 69.6907 334.364 69.5757 335.187 70.2561L345.675 78.9294L343.21 81.9101Z"
        fill="white"
      />
      <path
        d="M333.356 94.5784L322.868 85.9051C322.045 85.2247 321.929 84.0052 322.61 83.1821C323.29 82.359 324.51 82.2433 325.333 82.9243L335.821 91.5977L333.356 94.5784Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          d="M343.21 81.9101L332.722 73.2368C331.899 72.5564 331.784 71.337 332.464 70.5138C333.144 69.6907 334.364 69.5757 335.187 70.2561L345.675 78.9294L343.21 81.9101Z"
          fill="white"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M333.356 94.5784L322.868 85.9051C322.045 85.2247 321.929 84.0052 322.61 83.1821C323.29 82.359 324.51 82.2433 325.333 82.9243L335.821 91.5977L333.356 94.5784Z"
          fill="white"
        />
      </g>
      <rect
        x="331.762"
        y="72.8183"
        width="5"
        height="15"
        rx="2.5"
        transform="rotate(-47.8435 331.762 72.8183)"
        fill="white"
        stroke="#2E3860"
      />
      <rect
        x="321.762"
        y="84.8183"
        width="5"
        height="15"
        rx="2.5"
        transform="rotate(-47.8435 321.762 84.8183)"
        fill="white"
        stroke="#2E3860"
      />
      <path
        d="M347.137 74.1002L346.753 73.7807L346.433 74.1637L328.868 95.1784L328.54 95.5716L328.941 95.8905L344.318 108.118C343.461 109.829 343.86 111.965 345.398 113.237L345.398 113.237C347.041 114.596 349.408 114.493 350.93 113.083C355.725 116.41 362.335 115.502 366.032 110.886L368.554 107.738C372.158 103.241 371.717 96.8193 367.727 92.8367C369.185 91.0474 368.928 88.4135 367.146 86.94C365.7 85.7435 363.693 85.6798 362.195 86.642L347.137 74.1002Z"
        fill="#EE4360"
        stroke="#2E3860"
      />
      <path d="M349.46 93.3009L338.629 84.3438L336.874 86.4661L347.704 95.4232L349.46 93.3009Z" fill="white" />
      <path d="M366 94L352 111" stroke="#2E3860" strokeLinecap="round" />
      <path d="M361 88.5L346 106.5" stroke="#2E3860" strokeLinecap="round" />
    </svg>
  );
};
